// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".result{color:#396;width:100%}.result span{display:none}.result th{text-align:left;padding:.5em;color:#fff;background-color:#396;cursor:pointer}.result th.asc:after{content:\"▴\"}.result th.desc:after{content:\"▾\"}.result td{padding:.5rem}.result tr:nth-child(2n){background-color:#ecf9f2}@media(max-width:992px){.result td:first-child,.result td:nth-child(2){display:inline;padding-right:0;padding-left:.5rem}.result span{display:inline}.result thead{display:none}}", ""]);
// Exports
module.exports = exports;
